"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var initialsAvatarLocal = function initialsAvatarLocal(theme) {
  return {
    backgroundColor: theme.color.secondary1["default"],
    textColor: theme.color.monochrome1["default"],
    size: {
      1: {
        sm: theme.typography.paragraph[1].fontMobile,
        md: theme.typography.paragraph[1].fontTablet,
        lg: theme.typography.paragraph[1].fontDesktop
      },
      2: {
        sm: theme.typography.paragraph[1].fontMobile,
        md: theme.typography.paragraph[1].fontTablet,
        lg: theme.typography.paragraph[1].fontDesktop
      },
      3: {
        sm: theme.typography.heading[2].fontMobile,
        md: theme.typography.heading[1].fontTablet,
        lg: theme.typography.heading[1].fontDesktop
      },
      4: {
        sm: theme.typography.heading[4].fontMobile,
        md: theme.typography.heading[2].fontTablet,
        lg: theme.typography.heading[2].fontDesktop
      },
      5: {
        sm: theme.typography.heading[5].fontMobile,
        md: theme.typography.heading[4].fontTablet,
        lg: theme.typography.heading[3].fontDesktop
      },
      6: {
        sm: theme.typography.heading[5].fontMobile,
        md: theme.typography.heading[4].fontTablet,
        lg: theme.typography.heading[3].fontDesktop
      }
    }
  };
};

var _default = initialsAvatarLocal;
exports["default"] = _default;
//# sourceMappingURL=InitialsAvatar.theme.js.map